import { useContrastQuery } from '../../../../../hooks/use-contrast-query'
import { SelectedValueReportingFacet } from '../../../../../api/queries/value-reporting/vr-vulnerabilities'
import { Query } from '../../../../../hooks/queries'
import {
  VrAggregationQueryArgs,
  VrRouteCoverageResolverResponse,
  getVrRouteCoverage
} from './queries/vr-route-coverage'

export function useVrRouteCoverage(
  organizationUuid: string,
  selectedFacets?: SelectedValueReportingFacet[]
) {
  const { data, isLoading, error } = useContrastQuery<
    VrAggregationQueryArgs,
    VrRouteCoverageResolverResponse
  >(
    [Query.VR_ROUTE_COVERAGE, organizationUuid, selectedFacets],
    getVrRouteCoverage,
    {
      organizationUuid,
      selectedFacets
    }
  )

  return {
    data,
    isLoading,
    error
  }
}
